export const styles = {
  container: 'tw-flex tw-flex-col tw-gap-2',
  searchWrapper: 'tw-px-3 tw-pt-2',
  list: 'tw-divide-y tw-divide-neutral-100',
  emptyMessage: 'tw-text-sm tw-text-neutral-500 tw-p-4 tw-text-center',
};
